import { InfoCircleOutlined, MessageOutlined } from "@ant-design/icons";
import { useState } from "react";
import CustomerDetailsModal from "./CustomerDetailsModal";
import { useTranslation } from "react-i18next";

export default function Channels() {
    const { t } = useTranslation();
    const [openDetails, setOpenDetails] = useState(false);

    return (
        <>
            <div
                className="
                    border border-gray-200
                    rounded-lg
                    p-4
                    flex justify-between
                    bg-white
                    dark:bg-[#141414]
                    dark:border-[#303030]
                "
            >
                <div className="flex flex-col gap-1">
                    {/* LEFT */}
                    <div className="flex gap-2 items-center">
                        {/* Avatar */}
                        <div
                            className="
                                w-[44px] h-[44px]
                                rounded-full
                                bg-gray-300
                                dark:bg-[#2a2a2a]
                                flex items-center justify-center
                                text-white text-lg font-semibold
                            "
                        >
                            9
                        </div>

                        {/* Info */}
                        <div>
                            <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                                99785075859547
                            </div>

                            <div className="text-gray-500 dark:text-gray-400 text-sm">
                                99785075859547
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="text-sm text-gray-700 text-000000e0">
                            {t('cd.page_name')}{" "}
                            <span className="italic text-gray-500 dark:text-gray-400">
                                {t('cd.unknown')}
                            </span>
                        </div>

                        <div className="mt-1 text-sm text-gray-700 text-000000e0 flex items-center gap-2">
                            {t('cd.source')}
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                                alt="whatsapp"
                                className="w-6 h-6"
                            />
                        </div>

                        <div className="mt-1 text-sm text-gray-700 text-000000e0">
                            ID: 84909506018@s.whatsapp.net
                        </div>
                    </div>
                </div>

                {/* RIGHT ICONS */}
                <div className="flex gap-2">
                    <button
                        onClick={() => setOpenDetails(true)}
                        className="
                                w-9 h-9
                                border border-gray-300
                                dark:border-[#303030]
                                rounded-md
                                flex items-center justify-center
                                text-gray-600
                                text-000000e0
                                hover:bg-gray-100
                                dark:hover:bg-[#1f1f1f]
                            "
                    >
                        <InfoCircleOutlined />
                    </button>

                    <button
                        className="
                                w-9 h-9
                                border border-gray-300
                                dark:border-[#303030]
                                rounded-md
                                flex items-center justify-center
                                text-gray-600
                                text-000000e0
                                hover:bg-gray-100
                                dark:hover:bg-[#1f1f1f]
                            "
                    >
                        <MessageOutlined />
                    </button>
                </div>
            </div >

            {/* Modal */}
            < CustomerDetailsModal
                open={openDetails}
                onClose={() => setOpenDetails(false)
                }
            />
        </>
    );
}